<template>
  <v-container fluid fill-height style="min-height: calc(100vh - 80px);">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="4" class="align-self-center">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12">
                <h2 class="text-md-h5">
                  Welcome Back
                </h2>
                <p>
                  Log in to continue your account.
                </p>
              </v-col>
              <v-col cols="12">
                <alertsp :alertdata="alertdata"></alertsp>
                <v-form
                  @submit.prevent="submitLogin"
                  ref="formlogin"
                  v-model="formin.valid"
                  lazy-validation>
                  <v-text-field
                    v-model="login.email"
                    :rules="rules.email"
                    label="Email"
                    name="email"
                    required>
                  </v-text-field>
                  <v-text-field
                    v-model="login.password"
                    :append-icon="formin.password ? 'visibility' : 'visibility_off'"
                    :rules="[rules.required, rules.minpass]"
                    :type="formin.password ? 'text' : 'password'"
                    name="password"
                    label="Password"
                    hint="At least 8 characters"
                    counter
                    @click:append="formin.password = !formin.password">
                  </v-text-field>
                  <v-checkbox
                    v-model="login.remember"
                    label="Remember me?">
                  </v-checkbox>
                  <v-btn
                    type="submit"
                    large
                    block
                    :loading="loading.login"
                    :disabled="loading.login || !formin.valid"
                    :color="maincolor"
                    class="white--text">
                    Log In
                  </v-btn>
                  <div class="mt-3" v-if="false">
                    <v-row>
                      <v-col cols="12" md="12">
                        <div>
                          <router-link :to="{ name: 'Forgetpass' }">
                            Forget Password?
                          </router-link>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.register"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark :color="maincolor">
          <v-toolbar-title>Forget Password</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDmodal('registrasi')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-row>
              <v-col md="6" offset-md="3">
                Test
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Login',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdatareg: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      login: false,
      regnew: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    login: {
      email: '',
      password: '',
      remember: true,
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => ((!!v && v.length >= 16) || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    dmodal: {
      register: false,
    },
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {},
  created: () => ({
  }),
  mounted() {
    // console.log('run');
  },
  methods: {
    closeDmodal(type) {
      if (type === 'registrasi') {
        this.dmodal.register = false;
      } else {
        this.dmodal.register = false;
      }
    },
    registerNew(item) {
      this.dmodal.register = true;
    },
    getMyIp() {
      this.axios
        .get('https://api.ipify.org/?format=json')
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    submitLogin() {
      this.alertdata.show = false;
      if (this.$refs.formlogin.validate()) {
        this.loading.login = true;
        this.axios
          .post(
            this.api + '/api/auth/login',
            qs.stringify(
              this.login,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.role === 'admin') {
                  this.$store.commit('AUTH_SUCCESS', resdata.data);
                  this.$router.push({ name: 'Home' });
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = 'Unauthorized access!';
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.login = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.login = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
